import React, {useEffect, useState} from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import {useNavigate, useParams} from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import {baseUrl, ipAddress, userLocation, userName} from '../Univ.js'
function GeneratePayslip() {
    const navigate = useNavigate();
    const {id} = useParams();
    const [selectedDate, setSelectedDate] = useState(new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000));
    const [empData, setempData] = useState({});
    const [registerFormData, setRegisterFormData] = useState({
        emp: '',
        other_earn: '',
        other_deduct: '',
        working: '',
        lop_days: '',
        lop: '',
        loan: '',
        pay: '',
        pay_month: '',
        payslip_no: '',
        status: '',
        addedby: '',
    });
    useEffect(() => {
        if (!empData.emp_id) return;
        const month =
            selectedDate.getFullYear() +
            "-" +
            String(selectedDate.getMonth() + 1).padStart(2, "0");
        axios.get(
            `${baseUrl}payroll-summary/?emp_id=${empData.emp_id}&month=${month}`
        )
            .then(res => {
                setRegisterFormData(prev => ({
                    ...prev,
                    working: res.data.working_days,
                    lop_days: res.data.lop_days
                }));
            })
            .catch(err => {
                console.log(err);
            });
    }, [empData, selectedDate]);
    useEffect(() => {
        fetchempData();
    }, []);
    function fetchempData() {
        const url = `${baseUrl}edit-emp/${id}/`;
        axios.get(url)
            .then(response => {
                setempData(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }
    const handleDateChange = (date) => {
        setSelectedDate(date);
    };
    const inputHandler = (e) => {
        const {name, value} = e.target;
        setRegisterFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };
    const calculateDeduction = () => {
        const {other_deduct, other_earn, lop_days, loan, working} = registerFormData;
        const ctc1 = empData.earnings;
        const base = parseInt(ctc1) / parseInt(working);
        const lop = parseInt(base) * parseFloat(lop_days);
        const deduction = parseInt(other_deduct) + parseInt(loan) + parseInt(lop);
        const pay = parseInt(other_earn) + parseInt(ctc1) - parseInt(deduction);
        setRegisterFormData((prevState) => ({
            ...prevState,
            pay,
            lop,
        }));
    };
    useEffect(() => {
        if (registerFormData.working !== '') {
            calculateDeduction();
        }
    }, [registerFormData]);
    const submitHandler = (e) => {
        e.preventDefault();
        const formData = new FormData();
        const formattedDate = moment(selectedDate).format('YYYY-MM-DD');
        axios.post(`${baseUrl}get_payslip_no/`)
            .then(response => {
                const payslip_no = response.data.value;
                formData.append('emp', id);
                formData.append('other_earn', registerFormData.other_earn);
                formData.append('other_deduct', registerFormData.other_deduct);
                formData.append('working', registerFormData.working);
                formData.append('lop_days', registerFormData.lop_days);
                formData.append('lop', registerFormData.lop);
                formData.append('loan', registerFormData.loan);
                formData.append('pay', registerFormData.pay);
                formData.append('pay_month', formattedDate);
                formData.append('payslip_no', payslip_no);
                formData.append('addedby', userName);
                formData.append('status', '1');
                formData.append('ip_add', ipAddress);
                formData.append('location', userLocation);
                axios.post(`${baseUrl}create-payslip/`, formData)
                    .then(response1 => {
                        if (response1.status == 200 || response1.status == 201) {
                            Swal.fire({
                                title: 'Payslip Generated Successfully Done.',
                                icon: 'success',
                                timer: 2000,
                                showConfirmButton: false
                            });
                            setTimeout(() => {
                                window.location.href = '/emp-list';
                            }, 2000);
                        }
                    })
                    .catch(error => {
                        console.log(error);
                        Swal.fire(
                            'Error!',
                            'Failed. Please try again later.',
                            'error'
                        );
                    });
            })
    };
    return (
        <section className="container mt-4">
            <div className="row">
                <div className="col-md-10 col-12 offset-1">
                    <div className='card'>
                        <h4 className='card-header text-center'>Employee Details</h4>
                        <div className='card-body'>
                            <div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <label htmlFor="Role" className="form-label">Employee ID / Name</label>
                                        <span style={{fontWeight: 'bold'}} className="ms-3">{empData.emp_id}</span>
                                        <span style={{fontWeight: 'bold'}} className="ms-3">{empData.employee}</span>
                                    </div>
                                    <div className="col-md-3">
                                        <label htmlFor="Gender" className="form-label">Gender</label>
                                        <span style={{fontWeight: 'bold'}} className="ms-3">{empData.gender}</span>
                                    </div>
                                    <div className="col-md-1">
                                        <img src={empData.employee_pic} alt="Thumbnail" className="thumbnail"
                                             style={{width: 120, height: 60}}/>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="Age" className="form-label">Age</label>
                                        <span style={{fontWeight: 'bold'}} className="ms-3">{empData.age}</span>
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="Mobile" className="form-label">Mobile</label>
                                        <span style={{fontWeight: 'bold'}} className="ms-3">{empData.mobile}</span>
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="Address" className="form-label">Address</label>
                                        <span style={{fontWeight: 'bold'}} className="ms-3">{empData.address}</span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="Marital" className="form-label">Marital Status</label>
                                        <span style={{fontWeight: 'bold'}} className="ms-3">{empData.marital}</span>
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="Blood Group" className="form-label">Blood Group</label>
                                        <span style={{fontWeight: 'bold'}} className="ms-3">{empData.blood}</span>
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="Religion" className="form-label">Religion</label>
                                        <span style={{fontWeight: 'bold'}} className="ms-3">{empData.religion}
                            </span>
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="Alt No" className="form-label">Alternate No</label>
                                        <span style={{fontWeight: 'bold'}} className="ms-3">{empData.alt_contact}
                            </span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="Email" className="form-label">Email</label>
                                        <span style={{fontWeight: 'bold'}} className="ms-3">{empData.email} </span>
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="Aadhar" className="form-label">Aadhar</label>
                                        <span style={{fontWeight: 'bold'}} className="ms-3">{empData.adhar} </span>
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="PAN No" className="form-label">PAN No</label>
                                        <span style={{fontWeight: 'bold'}} className="ms-3">{empData.pan} </span>
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="Aadhar" className="form-label">Passport No</label>
                                        <span style={{fontWeight: 'bold'}} className="ms-3">{empData.passport} </span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="Status" className="form-label">Employment Status</label>
                                        <span style={{fontWeight: 'bold'}} className="ms-3">{empData.emp_status}</span>
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="Date" className="form-label">Date of Joining</label>
                                        <span style={{fontWeight: 'bold'}} className="ms-3">{empData.doj}</span>
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="education" className="form-label">Education
                                            Qualification</label>
                                        <span style={{fontWeight: 'bold'}} className="ms-3">{empData.education} </span>
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="Aadhar" className="form-label">Experience</label>
                                        <span style={{fontWeight: 'bold'}} className="ms-3">{empData.experience} </span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12 mb-3">
                                        <label htmlFor="Department" className="form-label">Department</label>
                                        <span style={{fontWeight: 'bold'}}
                                              className="ms-2">{empData.department && empData.department.department}</span>
                                        -<span style={{fontWeight: 'bold'}}
                                               className="ms-3">{empData.designation && empData.designation.designation}</span>
                                    </div>
                                </div>
                                <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
                                    <i className="fa-solid fa-indian-rupee-sign" aria-hidden="true"
                                       style={{color: 'red'}}></i>
                                    Account Details
                                </h3>
                                <div className="row mt-4">
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="Account No" className="form-label">Bank Account No</label>
                                        <span style={{fontWeight: 'bold'}} className="ms-3">{empData.account} </span>
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="Bank Branch Detail" className="form-label">Bank Branch
                                            Detail</label>
                                        <span style={{fontWeight: 'bold'}} className="ms-3">{empData.branch} </span>
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="ESI No" className="form-label">ESI No</label>
                                        <span style={{fontWeight: 'bold'}} className="ms-3">{empData.esi} </span>
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="PF No" className="form-label">PF No</label>
                                        <span style={{fontWeight: 'bold'}} className="ms-3">{empData.pf} </span>
                                    </div>
                                </div>
                                <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
                                    <i className="fa-solid fa-indian-rupee-sign" aria-hidden="true"
                                       style={{color: 'red'}}></i>
                                    Salary Details
                                </h3>
                                <div className="row mt-4">
                                    <div className="col-md-5 mb-2">
                                        <label htmlFor="Basic Salary" className="form-label">Basic Salary</label>
                                        <span style={{fontWeight: 'bold'}} className="ms-2">{empData.basic} </span>
                                    </div>
                                    <div className="col-md-5 mb-2">
                                        <label htmlFor="Prof Tax" className="form-label">Prof Tax</label>
                                        <span style={{fontWeight: 'bold'}} className="ms-1">{empData.prof} </span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-5 mb-2">
                                        <label htmlFor="HRA" className="form-label">HRA</label>
                                        <span style={{fontWeight: 'bold'}} className="ms-2">{empData.hra} </span>
                                    </div>
                                    <div className="col-md-5 mb-2">
                                        <label htmlFor="TDS" className="form-label">TDS</label>
                                        <span style={{fontWeight: 'bold'}} className="ms-1">{empData.tds} </span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-5 mb-2">
                                        <label htmlFor="Allowance" className="form-label">Allowance</label>
                                        <span style={{fontWeight: 'bold'}} className="ms-2">{empData.allowance} </span>
                                    </div>
                                    <div className="col-md-5 mb-2">
                                        <label htmlFor="Other Deduction" className="form-label">Other Deduction</label>
                                        <span style={{fontWeight: 'bold'}}
                                              className="ms-1">{empData.other_deduct} </span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-5 mb-2">
                                        <label htmlFor="Spl Allowance" className="form-label">Spl Allowance</label>
                                        <span style={{fontWeight: 'bold'}} className="ms-2">{empData.spl} </span>
                                    </div>
                                    <div className="col-md-5 mb-2">
                                        <label htmlFor="TDS" className="form-label">Employee PF Contri. @12%</label>
                                        <span style={{fontWeight: 'bold'}} className="ms-3">{empData.empf} </span>
                                    </div>
                                </div>
                                <form>
                                    <div className="row">
                                        <div className="col-md-5 mb-2">
                                            <label htmlFor="Other Earnings" className="form-label">Other
                                                Earnings</label>
                                            <span style={{fontWeight: 'bold'}}
                                                  className="ms-2">{empData.other_earn} </span>
                                        </div>
                                        <div className="col-md-5 mb-2">
                                            <label htmlFor="Empl ESI" className="form-label">Employee ESI @0.75%</label>
                                            <span style={{fontWeight: 'bold'}} className="ms-3">{empData.emesi} </span>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-5 mb-2">
                                            <label htmlFor="Earnings per Month" className="form-label">Total Earnings/
                                                Month</label>
                                            <span style={{fontWeight: 'bold'}}
                                                  className="ms-2">{empData.earnings} </span>
                                        </div>
                                        <div className="col-md-5 mb-2">
                                            <label htmlFor="Total Deduction per Month" className="form-label">Total
                                                Deduction/ Month</label>
                                            <span style={{fontWeight: 'bold'}}
                                                  className="ms-2">{empData.deduction} </span>
                                        </div>
                                        <div className="col-md-2 mb-2">
                                            <label htmlFor="CTC per Month" className="form-label">Total CTC</label>
                                            <span style={{fontWeight: 'bold'}} className="ms-2">{empData.ctc}</span>
                                        </div>
                                    </div>
                                    <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
                                        <i className="fa-solid fa-indian-rupee-sign" aria-hidden="true"
                                           style={{color: 'red'}}></i>
                                        Current Month Details
                                    </h3>
                                    <div className="row">
                                        <div className="col-md-4 mb-3">
                                            <label htmlFor="Other Earnings" className="form-label">Other
                                                Earnings</label>
                                            <input type="number" placeholder="Other Earnings" className="form-control"
                                                   name="other_earn" id="other_earn" value={registerFormData.other_earn}
                                                   onChange={inputHandler}/>
                                        </div>
                                        <div className="col-md-4 mb-2">
                                            <label htmlFor="Other Deduction" className="form-label">Other
                                                Deduction</label>
                                            <input type="number" placeholder="Other Deduction" className="form-control"
                                                   maxLength={16}
                                                   name="other_deduct" id="other_deduct"
                                                   value={registerFormData.other_deduct} onChange={inputHandler}/>
                                        </div>
                                        <div className="col-md-4 mb-2">
                                            <label htmlFor="Working Days" className="form-label">Working Days</label>
                                            <input type="number" placeholder="Other Deduction" className="form-control"
                                                   maxLength={16}
                                                   name="working" id="working" value={registerFormData.working}
                                                   onChange={inputHandler}/>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-4 mb-3">
                                            <label htmlFor="Lop Days" className="form-label">LOP Days</label>
                                            <input type="number" placeholder="LOP Days" className="form-control"
                                                   name="lop_days" id="lop_days" value={registerFormData.lop_days}
                                                   onChange={inputHandler}/>
                                        </div>
                                        <div className="col-md-4 mb-2">
                                            <label htmlFor="Lop Amount" className="form-label">LOP Amount</label>
                                            <input type="number" taxIndex="0" placeholder="LOP Amount"
                                                   className="form-control" maxLength={16}
                                                   name="lop" id="lop" value={registerFormData.lop}
                                                   onChange={inputHandler} readOnly/>
                                        </div>
                                        <div className="col-md-4 mb-2">
                                            <label htmlFor="Loan EMI" className="form-label">Loan EMI</label>
                                            <input type="number" placeholder="Loan EMI" className="form-control"
                                                   maxLength={16}
                                                   name="loan" id="loan" value={registerFormData.loan}
                                                   onChange={inputHandler}/>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6 mb-3">
                                            <label htmlFor="Salary Payable" className="form-label">Salary
                                                Payable</label>
                                            <input type="number" placeholder="Salary Payable" className="form-control"
                                                   name="pay" id="pay" value={registerFormData.pay}
                                                   onChange={inputHandler} readOnly/>
                                        </div>
                                        <div className="col-md-3 mb-3">
                                            <label htmlFor="Date" className="form-label">Month</label>
                                            <DatePicker
                                                className="form-control"
                                                name="pay_month"
                                                id="pay_month"
                                                selected={selectedDate}
                                                onChange={handleDateChange}
                                                dateFormat="MM/yyyy"
                                                showMonthYearPicker
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12 text-center">
                                            <button type="button" onClick={submitHandler}
                                                    className="btn btn-success">Generate
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
export default GeneratePayslip;
